import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormGroup, FormControl } from '@angular/forms';
import { SystemService } from '../../services/system.service'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
@Component({
	selector: 'app-mail',
	templateUrl: './mail.component.html',
	styleUrls: ['./mail.component.scss']
})
export class MailComponent implements OnInit {
	emailForm: UntypedFormGroup;
	color = 'blue';
	constructor(
		private globalSearchService: GlobalSearchService,
		private systemService: SystemService,
		private location: Location,
		private fb: UntypedFormBuilder,
		private route: ActivatedRoute,
		private router: Router,
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {

		this.route.queryParams.subscribe((params) => {
			if (params['oauth_ok']) {
				this.globalSearchService.showNotification('Microsoft Outlook authorization saved.', 'success', 'bottom', 'right');
				this.router.navigate([], { relativeTo: this.route, queryParams: {}, replaceUrl: true });
				this.loadForm();
			} else if (params['oauth_error']) {
				this.globalSearchService.showNotification('Microsoft authorization failed or was cancelled.', 'warning', 'bottom', 'right');
				this.router.navigate([], { relativeTo: this.route, queryParams: {}, replaceUrl: true });
			}
		});

		this.emailForm = this.fb.group({
			config_mail_parameter: [],
			config_mail_smtp_hostname: [],
			config_mail_smtp_username: [],
			config_mail_smtp_password: [],
			config_mail_smtp_port: [],
			config_mail_smtp_timeout: [],
			config_mail_engine: [],
			config_mail_alert_email: [],
			config_mail_smtp_auth: ['login'],
			config_mail_oauth_tenant_id: [],
			config_mail_oauth_client_id: [],
			config_mail_oauth_refresh_token: [],
		});

		this.loadForm();

	}

	loadForm() {
		this.systemService.getEmailSettings().subscribe( (result: any) => {

			this.emailForm = this.fb.group({
				config_mail_parameter: [result.config_mail_parameter],
				config_mail_smtp_hostname: [result.config_mail_smtp_hostname],
				config_mail_smtp_username: [result.config_mail_smtp_username],
				config_mail_smtp_password: [result.config_mail_smtp_password],
				config_mail_smtp_port: [result.config_mail_smtp_port],
				config_mail_smtp_timeout: [result.config_mail_smtp_timeout],
				config_mail_alert_email:  [result.config_mail_alert_email],
				config_mail_engine: [result.config_mail_engine],
				config_mail_smtp_auth: [result.config_mail_smtp_auth || 'login'],
				config_mail_oauth_tenant_id: [result.config_mail_oauth_tenant_id],
				config_mail_oauth_client_id: [result.config_mail_oauth_client_id],
				config_mail_oauth_refresh_token: [result.config_mail_oauth_refresh_token],
			});
		});
	}

	startMicrosoftOAuth(): void {
		const returnUrl = `${window.location.origin}${window.location.pathname}#/system/email`;
		this.systemService.beginMailOAuth(returnUrl).subscribe((res: any) => {
			if (res && res.success && res.authorize_url) {
				window.location.href = res.authorize_url;
			} else {
				this.globalSearchService.showNotification((res && res.message) ? res.message : 'Could not start Microsoft sign-in.', 'warning', 'bottom', 'right');
			}
		});
	}

	saveEmailSettings() {
		if(this.emailForm.valid) {
			this.systemService.saveEmailSettings(this.emailForm.value).subscribe(result => {
				this.loadForm();
				this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
			});
		}
	}

	back(): void {
		this.location.back()
	}

	update() {

	}

}
